import {connect} from "react-redux";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {selectInvites, selectProjects, selectUsers} from "../../redux/selectors/firebase";
import { Box, Card, CardContent, Tab, Tabs } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {TabPanel} from "./TabPanel";
import Users from "./Users";
import {getAnalytics, logEvent} from "firebase/analytics";
import {selectProject} from "../../redux/selectors/editor";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {Invites as InvitesType, ProjectDetails} from "../../redux/types/firebase";
import Invites from "./Invites";

const useStyles = makeStyles(theme => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        margin: theme.spacing(8),
    },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    screen: {
        display: "flex",
        flexDirection: "column",
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    tabPanelContents: {
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    tabPanel: {
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
    },
}));

type Props = {
    invites: InvitesType
    project: string
    projects: {[key: string]: ProjectDetails }
    users: any
}
function Admin({invites, project, projects, users}: Props) {
    const classes = useStyles();
    const [adminTab, setAdminTab] = useState(0);
    const handleChangeTab = (event: ChangeEvent<{}>, value: any) => {
        setAdminTab(value);
    };
    const {trackInvites, trackUsers, untrack} = useContext(FirebaseContext);

    useEffect(() => {
        logEvent(getAnalytics(), "page_view", {
            page_location: "/admin"
        });
    }, []);
    useEffect(() => {
        trackInvites();
        trackUsers();
        return () => {
            untrack("invites");
            untrack("users");
        }
    }, [trackInvites, trackUsers, untrack]);
    return (
        <Box className={classes.screen}>
            <Card className={classes.card}>
                <CardContent className={classes.content}>
                    <Tabs value={adminTab} onChange={handleChangeTab}>
                        <Tab label="Users"/>
                        <Tab label="Invites"/>
                    </Tabs>
                    <TabPanel className={classes.tabPanel} value={adminTab} index={0}>
                        <Box className={classes.tabPanelContents}><Users users={users}/></Box>
                    </TabPanel>
                    <TabPanel className={classes.tabPanel} value={adminTab} index={1}>
                        <Box className={classes.tabPanelContents}>
                            <Invites invites={invites} users={users}/>
                        </Box>
                    </TabPanel>
                </CardContent>
            </Card>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    invites: selectInvites(store),
    project: selectProject(store),
    projects: selectProjects(store),
    users: selectUsers(store)
});

export default connect(mapStateToProps, {
})(Admin);
